import { FormFieldDefinition } from '../../../../../../generic/universal-table/types/form.types'
import { GrowerUiRow } from '../types/growerTable.types'

export const growerTableFormFields: FormFieldDefinition<GrowerUiRow>[] = [
  {
    name: 'GrowerName',
    label: 'שם גדל',
    inputType: 'text',
    required: true,
    placeholder: 'הזן שם גדל',
    validationRules: {
      required: true,
      minLength: 1,
      maxLength: 100,
    },
  },
  {
    // getOptions is injected in GrowerTableModule.tsx
    name: 'ClientID',
    label: 'לקוח',
    inputType: 'searchable-select',
    required: false,
  },
  {
    name: 'AccounID',
    label: 'מספר חשבון',
    inputType: 'text',
    required: false,
    placeholder: 'מספר חשבון',
    validationRules: {
      maxLength: 50,
    },
  },
  {
    name: 'GGN',
    label: 'GGN',
    inputType: 'text',
    required: false,
    placeholder: 'GGN',
    validationRules: {
      maxLength: 50,
    },
  },
  {
    name: 'GroupID',
    label: 'קבוצה',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Farm_Num',
    label: 'מספר חווה',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Exporter_Num',
    label: 'מספר יצואן',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Kanat_Num',
    label: 'מספר קנת',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Muaza_Num',
    label: 'מספר מועצה',
    inputType: 'text',
    required: false,
    placeholder: 'מספר מועצה',
    validationRules: { maxLength: 50 },
  },
  {
    name: 'FieldMan',
    label: 'שדאי',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'ActivityType',
    label: 'סוג פעילות',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Payment_Method',
    label: 'שיטת תשלום',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Active',
    label: 'פעיל',
    inputType: 'boolean-select',
    required: false,
    defaultValue: true,
  },
  {
    name: 'Pay_Discharge',
    label: 'תשלום פריקה',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Pay_Levies',
    label: 'תשלום היטלים',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Pay_Logistics',
    label: 'תשלום לוגיסטיקה',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'PickUp',
    label: 'איסוף עצמי',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
]
